import graphqlClient from "../../../apollo";

class SurveyViewConfigProvider {
    fetchSurveyViewConfig(){
        return graphqlClient.query({
            query: require('./gql/SurveyViewConfig/fetchSurveyViewConfig.graphql'),
            fetchPolicy: "network-only"
        })
    }

    updateSurveyViewConfig(input){
        return graphqlClient.mutate({
            mutation: require('./gql/SurveyViewConfig/updateSurveyViewConfig.graphql'),
            variables: {input}
        })
    }
}

export default new SurveyViewConfigProvider()